import { useState } from 'react';
import { Link } from 'react-router-dom';
// Import assets
import instagramIcon from '../assets/insta.png';
import facebookIcon from '../assets/fb.png';
import twitterIcon from '../assets/twit.png';
import youtubeIcon from '../assets/you.png';
import linkedinIcon from '../assets/link.png';
import '../styles/Contact.css'; // Contact ki CSS

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  if (submitted) {
    return (
      <div className="contact-page-wrapper">
        <div className="contact-bg-glow contact-bg-glow-1"></div>
        <div className="contact-bg-glow contact-bg-glow-2"></div>
        <div className="contact-container">
          <div className="contact-success-card">
            <div className="contact-success-icon-wrapper">
              <span className="contact-success-icon">✅</span>
            </div>
            <h2 className="contact-success-title">Message Sent!</h2>
            <p className="contact-success-text">
              Thank you for contacting us. We'll get back to you within 24 hours.
            </p>
            <button 
              className="contact-success-btn" 
              onClick={() => setSubmitted(false)}
            >
              Send Another Message
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-page-wrapper">
      {/* Animated Background Glows */}
      <div className="contact-bg-glow contact-bg-glow-1"></div>
      <div className="contact-bg-glow contact-bg-glow-2"></div>
      <div className="contact-bg-glow contact-bg-glow-3"></div>

      <div className="contact-container">
        {/* ============================= */}
        {/* HERO SECTION */}
        {/* ============================= */}
        <section className="contact-hero-section">
          <div className="contact-hero-content">
            <span className="contact-hero-badge">📧 Get in Touch</span>
            <h1 className="contact-hero-title">
              Let's <span className="contact-hero-highlight">Connect</span>
            </h1>
            <p className="contact-hero-description">
              Have questions about events, registration, or partnerships? 
              We'd love to hear from you. Reach out and we'll get back to you soon!
            </p>
          </div>
        </section>

        {/* ============================= */}
        {/* CONTACT GRID */}
        {/* ============================= */}
        <div className="contact-grid-wrapper">
          {/* Contact Form */}
          <div className="contact-form-card">
            <div className="contact-form-header">
              <span className="contact-form-icon">✉️</span>
              <h2>Send a Message</h2>
              <p>Fill in the details and we'll respond within 24 hours</p>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form-group">
                <label>
                  Full Name <span className="contact-required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                  className="contact-input"
                />
              </div>

              <div className="contact-form-group">
                <label>
                  Email Address <span className="contact-required">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="you@example.com"
                  className="contact-input"
                />
              </div>

              <div className="contact-form-group">
                <label>Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="What is this about?"
                  className="contact-input"
                />
              </div>

              <div className="contact-form-group">
                <label>
                  Message <span className="contact-required">*</span>
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Write your message here..."
                  className="contact-textarea"
                ></textarea>
              </div>

              <button type="submit" className="contact-submit-btn">
                Send Message
                <svg className="contact-btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </button>
            </form>
          </div>

          {/* Contact Info */}
          <div className="contact-info-card">
            <div className="contact-info-header">
              <span className="contact-info-icon">📌</span>
              <h2>Contact Information</h2>
              <p>Reach out to us through any of these channels</p>
            </div>

            <div className="contact-info-items">
              <div className="contact-info-item">
                <div className="contact-info-icon-wrapper">
                  <span>📍</span>
                </div>
                <div>
                  <strong>Address</strong>
                  <p> VernaEvents, Justice Dwarakanath Rd, Gaza Park, Sreepally, Bhowanipore, Kolkata, West Bengal 700020</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon-wrapper">
                  <span>📧</span>
                </div>
                <div>
                  <strong>Email</strong>
                  <p>info@vernaevents.com</p>
                  <p className="contact-info-sub">support@vernaevents.com</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon-wrapper">
                  <span>📱</span>
                </div>
                <div>
                  <strong>Phone</strong>
                  <p>+91 8017339796</p>
                  <p className="contact-info-sub">+91 8017339796 (WhatsApp)</p>
                </div>
              </div>

              <div className="contact-info-item">
                <div className="contact-info-icon-wrapper">
                  <span>🕐</span>
                </div>
                <div>
                  <strong>Working Hours</strong>
                  <p>Monday - Saturday: 9:00 AM - 6:00 PM</p>
                  <p className="contact-info-sub">Sunday: Closed</p>
                </div>
              </div>
            </div>

            {/* Social Links */}
            <div className="contact-social-section">
              <h4>Follow Us</h4>
              <div className="contact-social-icons">
                <a href="#" className="contact-social-icon" title="Instagram">
                  <img src={instagramIcon} alt="Instagram" />
                </a>
                <a href="#" className="contact-social-icon" title="Facebook">
                  <img src={facebookIcon} alt="Facebook" />
                </a>
                <a href="#" className="contact-social-icon" title="Twitter">
                  <img src={twitterIcon} alt="Twitter" />
                </a>
                <a href="#" className="contact-social-icon" title="YouTube">
                  <img src={youtubeIcon} alt="YouTube" />
                </a>
                <a href="#" className="contact-social-icon" title="LinkedIn">
                  <img src={linkedinIcon} alt="LinkedIn" />
                </a>
              </div>
            </div>

            {/* Quick Response Note */}
            <div className="contact-quick-response">
              <span>⚡</span>
              <div>
                <strong>Quick Response</strong>
                <p>We typically respond within 24 hours</p>
              </div>
            </div>
          </div>
        </div>

        {/* ============================= */}
        {/* MAP SECTION */}
        {/* ============================= */}
        <section className="contact-map-section">
          <div className="contact-map-container">
            <div className="contact-map-content">
              <span className="contact-map-badge">📍 Find Us</span>
              <h2 className="contact-map-title">
                Visit Our <span className="contact-map-highlight">Location</span>
              </h2>
              <p className="contact-map-description">
                Come visit us at our office. We'd love to meet you in person!
              </p>
            </div>
            <div className="contact-map-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.402342897642!2d72.825564!3d19.0760!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c9a0b8d0f8d9%3A0x0!2sMumbai%2C%20Maharashtra%2C%20India!5e0!3m2!1sen!2sin!4v1700000000000"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="VernaEvents Location"
              ></iframe>
            </div>
          </div>
        </section>

        {/* ============================= */}
        {/* CTA SECTION */}
        {/* ============================= */}
        <section className="contact-cta-section">
          <div className="contact-cta-content">
            <span className="contact-cta-icon">💬</span>
            <h2 className="contact-cta-title">
              Have a <span className="contact-cta-highlight">Question</span>?
            </h2>
            <p className="contact-cta-description">
              Check out our FAQ page for quick answers to common questions
            </p>
            <Link to="/faq" className="contact-cta-btn">
              Visit FAQ →
            </Link>
          </div>
        </section>

       
        
      </div>
    </div>
  );
}

export default Contact;